<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="workRegionGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
        sort-az="last_name"
      >
        <template v-slot:buttons>
          <WorkRegionModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_client_addresses',
              })
            "
            :create="true"
          />
        </template>
        <WorkRegionTable :items="workRegionGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import WorkRegionTable from 'components/setting/workRegion/WorkRegionTable'
import WorkRegionModal from 'components/setting/workRegion/WorkRegionModal'

export default {
  name: 'WorkRegion',
  components: {
    TemplateView,
    TemplatePageGrid,
    WorkRegionTable,
    WorkRegionModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  computed: {
    ...mapGetters('workRegion', ['workRegionGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  methods: {
    ...mapActions('workRegion', ['onWorkRegionGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkRegionGrid(data)
    },
  },
}
</script>
